<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Status Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-progress
      class="mt-2 status-progress-bar"
      :max="100"
      :value="100 * (current / stages.length)"
    >
      <b-progress-bar
        v-for="(stage, index) in stages"
        :key="index"
        :value="100 * (1 / stages.length)"
        :variant="stage.variant"
        :title="stage.current && 'Current Status'"
        :class="`status-progress-bar-segment ${
          stage.date ? 'font-weight-bold' : 'pgb-muted'
        } ${stage.current && 'current-status'}`"
      >
        {{ stage.name
        }}<span v-if="stage.date">{{ stage.date | moment("L") }}</span>
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
import moment from "moment";
import SampleStatusLogCollection from "@/collections/lab/SampleStatusLogCollection";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "StatusProgress",
  props: {
    log_collection: {
      type: Object,
      default: () => new SampleStatusLogCollection(),
    },
    current_status: {
      type: String,
      default: null,
    },
    status_group: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      current: 0,
      status_collection: null,
    };
  },
  computed: {
    stages() {
      const log_collection = {};
      let stages = [];

      this.log_collection.models.length &&
        this.log_collection.each((log) => {
          if (log.getStatus().id && log.created_at) {
            log_collection[log.getStatus().id] = moment(log.created_at);
          }
        });
      this.status_collection.models.length &&
        this.status_collection.each((status, index) => {
          if (status.status) {
            const date = log_collection[status.id]
              ? log_collection[status.id]
              : null;

            if (date) {
              this.current = index + 1;
            }

            stages = [
              ...stages,
              {
                name: status.status,
                variant: status.getVariant(),
                current: this.current_status === status.status,
                class_prefix:
                  status.status === "In Progress"
                    ? "in-progress"
                    : status.status.toLowerCase(),
                date,
              },
            ];
          }
        });

      return stages;
    },
  },
  async created() {
    this.loading = true;

    this.status_collection = await getCollection({
      collection_type: `${this.status_group}_status`,
      sort: [
        {
          logic: "sortAddAsc",
          field: "order",
        },
      ],
      message: this.$bvToast,
    });

    this.loading = false;
  },
};
</script>

<style>
.pgb-muted {
  opacity: 0.5;
}
.status-progress-bar {
  height: auto;
  align-items: center;
  background-color: transparent;
}
.status-progress-bar-segment {
  height: 40px;
}
.current-status {
  border: 3px solid #20a8d8;
  border-radius: 5px;
  height: 46px;
}
</style>
